import {
  isServer,
  QueryCache,
  QueryClient,
  defaultShouldDehydrateQuery,
} from '@tanstack/react-query'
import { endSessionOnAuthFailure, rearmSessionEndOnLogin } from '@/utils/query/endSessionOnAuthFailure'

function makeQueryClient(queryCache?: QueryCache) {
  return new QueryClient({
    queryCache,
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
      dehydrate: {
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === 'pending',
      },
    },
  })
}

let browserQueryClient: QueryClient | undefined = undefined

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient()
  } else {
    if (!browserQueryClient) {
      // Only the browser client ends a rejected session: server clients are
      // built per request and must never log anyone out.
      const client = makeQueryClient(new QueryCache({
        onError: (error, query) => endSessionOnAuthFailure(client, error, query),
        onSuccess: rearmSessionEndOnLogin,
      }))
      browserQueryClient = client
    }
    return browserQueryClient
  }
}
